import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { name: String, props: Object, onConnect: Boolean }

  connect() {
    if (!this.onConnectValue || document.documentElement.hasAttribute("data-turbo-preview")) return

    // Disarm before Turbo snapshots the page, so Back and Forward restores don't fire again
    this.onConnectValue = false
    this.capture()
  }

  capture() {
    window.posthog?.capture(this.nameValue, this.propsValue)
  }
}
